import React, { useEffect } from "react";
import { Card } from "primereact/card";
import { RadioButton } from "primereact/radiobutton";
import { useForm, Controller } from "react-hook-form";
import useShareHolders from "./useShareHolders";
import { InputText } from "primereact/inputtext";
import { useLocation, useNavigate } from "react-router-dom";
import API_ROUTES from "../../api-routes";
import apiService from "../../services/service";
import { useDispatch } from "react-redux";
import { updateShareHolder } from "./shareHoldersSlice";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";

const ShareHoldersRegistration = ({
  onSave,
  isBtnLoading,
  setIsBtnLoading,
}) => {
  const { ingredient, setIngredient, editMsg, setEditMsg } =
    useShareHolders(onSave);
  const location = useLocation();
  const { rowData } = location.state || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const entityId = rowData ? rowData.entity : null;

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: rowData?.name || "",
      last_name: rowData?.last_name || "",
      preferred_name: rowData?.preferred_name || "",
      other_name: rowData?.other_name || "",

      legal_name: rowData?.legal_name || "",
      point_of_contact: rowData?.point_of_contact || "",
      email: rowData?.email || "",
      phone_code: rowData?.phone_code || "",
      phone: rowData?.phone || "",
      number_of_shares: rowData?.number_of_shares || "",
      share_percentage: rowData?.share_percentage || "",
    },
  });

  const handleFormSubmit = (data) => {
    if (rowData) {
      handleConfirmEdit(data);
    } else {
      const formData = {
        ...data,
        type: ingredient,
      };

      onSave(formData);

      reset({
        name: "",
        last_name: "",
        preferred_name: "",
        other_name: "",
        legal_name: "",
        point_of_contact: "",
        email: "",
        phone_code: "",
        phone: "",
        number_of_shares: "",
        share_percentage: "",
      });
      setIngredient(null);
    }
  };

  const handleSkip = () => {
    if (entityId) {
      navigate(`/entity/${entityId}/share-holders`);
    } else {
      window.location.reload();
    }
  };

  const handleRadioBtn = (e) => {
    setIngredient(e.value);
    reset({
      name: "",
      last_name: "",
      preferred_name: "",
      other_name: "",
      legal_name: "",
      point_of_contact: "",
      email: "",
      phone_code: "",
      phone: "",
      number_of_shares: "",
      share_percentage: "",
    });
  };

  useEffect(() => {
    if (rowData) {
      reset({
        name: rowData.name || "",
        last_name: rowData.last_name || "",
        preferred_name: rowData.preferred_name || "",
        other_name: rowData.other_name || "",
        legal_name: rowData.legal_name || "",
        point_of_contact: rowData.point_of_contact || "",
        email: rowData.email || "",
        phone_code: rowData.phone_code || "",
        phone: rowData.phone || "",
        number_of_shares: rowData.number_of_shares || "",
        share_percentage: rowData.share_percentage || "",
      });
    } else {
      reset({
        name: "",
        last_name: "",
        preferred_name: "",
        other_name: "",
        legal_name: "",
        point_of_contact: "",
        email: "",
        phone_code: "",
        phone: "",
        number_of_shares: "",
        share_percentage: "",
      });
    }
  }, [rowData, reset]);

  useEffect(() => {
    if (editMsg && entityId) {
      navigate(`/entity/${entityId}/share-holders`, {
        state: { editMsg: editMsg },
      });
      reset({
        name: "",
        last_name: "",
        preferred_name: "",
        other_name: "",
        legal_name: "",
        point_of_contact: "",
        email: "",
        phone_code: "",
        phone: "",
        number_of_shares: "",
        share_percentage: "",
      });
    }
  }, [editMsg, entityId, navigate, reset]);

  const handleConfirmEdit = async (data) => {
    setIsBtnLoading(true);
    const shareHolderUpdatedData = {
      id: rowData.id || "",
      name: data.name,
      last_name: data.last_name,
      preferred_name: data.preferred_name,
      other_name: data.other_name,
      legal_name: data.legal_name,
      point_of_contact: data.point_of_contact,
      email: data.email,
      phone_code: data.phone_code,
      phone: data.phone,
      number_of_shares: data.number_of_shares,
      share_percentage: data.share_percentage,
    };

    try {
      const res = await apiService(API_ROUTES.UPDATE_SHAREHOLDER, "PUT", {
        body: JSON.stringify(shareHolderUpdatedData),
        replace: { id: shareHolderUpdatedData.id },
      });

      if (res.status) {
        dispatch(
          updateShareHolder({
            id: shareHolderUpdatedData.id,
            data: shareHolderUpdatedData,
          }),
        );
        const n =
          data?.preferred_name ||
          [data?.name, data?.other_name, data?.last_name]
            .filter(Boolean)
            .join(" ");

        setEditMsg(
          `${n} ${data?.legal_name} profile has been successfully edited. `,
        );
      } else {
        console.log("Update failed");
      }
      setIsBtnLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setIsBtnLoading(false);
    }
  };

  return (
    <>
      <Card className="gen-card h-full">
        <div className="appointment-container flex justify-content-between formgrid grid grid-nogutter">
          <div>
            <p className="appointment">Appointment Details</p>
            <p className="general-info-para">
              Enter all the details for this appointment
            </p>
          </div>
        </div>
        {rowData ? null : (
          <div className="formgrid grid">
            <div className="field col-12">
              <p className="appointment-para">
                Select the type of shareholder you want to register
              </p>
            </div>
            <div className="field col-6">
              <div className="appointment-card h-full">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="ingredient1"
                    name="type"
                    value="Individual"
                    onChange={handleRadioBtn}
                    checked={ingredient === "Individual"}
                  />
                  <label htmlFor="ingredient1" className="ml-3">
                    <div className="flex flex-column justify-content-start">
                      <p className="appointment-para">Individual</p>
                      <p className="appointment-radio-para">
                        A natural person who owns shares in the company.
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="field col-6">
              <div className="appointment-card h-full">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="ingredient2"
                    name="type"
                    value="Corporate"
                    onChange={handleRadioBtn}
                    checked={ingredient === "Corporate"}
                  />
                  <label htmlFor="ingredient2" className="ml-3">
                    <div className="flex flex-column justify-content-start">
                      <p className="appointment-para">Corporate</p>
                      <p className="appointment-radio-para">
                        A legal entity that owns shares in the company.
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
        {(ingredient || rowData) && (
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="formgrid grid">
              {ingredient === "Individual" ||
              (rowData && rowData.type === "Individual") ? (
                <>
                  <div className="field col-6">
                    <label className="contact-label mt-2">
                      Given name(s) *{" "}
                      <span
                        id="given-name-info"
                        className="pi pi-info-circle"
                      ></span>
                      <Tooltip
                        target="#given-name-info"
                        content="This is usually the person first name or the name they usually go by."
                        position="right"
                        className="custom-tooltip tooltip-custom-format"
                      />
                    </label>
                    <Controller
                      name="name"
                      control={control}
                      defaultValues
                      rules={{
                        required: "Given Name is required.",
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "Special characters are not allowed.",
                        },
                      }}
                      render={({ field }) => (
                        <InputText
                          {...field}
                          type="text"
                          placeholder="Enter given name(s)"
                          className={`input-field appearance-none outline-none w-full ${
                            errors.name ? "error" : ""
                          }`}
                        />
                      )}
                    />
                    {errors.name && (
                      <small className="error-message">
                        {errors.name.message}
                      </small>
                    )}
                  </div>

                  <div className="field col-6">
                    <label className="contact-label mt-2">
                      Other Name(s)
                      <span
                        id="other-name-info"
                        className="pi pi-info-circle info-circle-span"
                      ></span>
                      <Tooltip
                        target="#other-name-info"
                        content="Any middle or extra names that the employee has. You can leave this blank if it doesn’t apply."
                        position="right"
                        className="tooltip-custom-format"
                      />
                    </label>
                    <Controller
                      name="other_name"
                      control={control}
                      defaultValues
                      rules={{
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "Special characters are not allowed.",
                        },
                      }}
                      render={({ field }) => (
                        <InputText
                          {...field}
                          type="text"
                          placeholder="Enter any other names, such as middle names or clan names"
                          className={`input-field appearance-none outline-none w-full ${
                            errors.name ? "error" : ""
                          }`}
                        />
                      )}
                    />
                    {errors.other_name && (
                      <small className="error-message">
                        {errors.other_name.message}
                      </small>
                    )}
                  </div>

                  <div className="field col-6">
                    <label className="contact-label mt-2">
                      Surname(s)
                      <span
                        id="surname-info"
                        className="pi pi-info-circle info-circle-span"
                      ></span>
                      <Tooltip
                        target="#surname-info"
                        content="This is usually a family name or last name. If employee has more than one, include them here."
                        position="right"
                        className="custom-tooltip tooltip-custom-format"
                      />
                    </label>
                    <Controller
                      name="last_name"
                      control={control}
                      defaultValues
                      rules={{
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "Special characters are not allowed.",
                        },
                      }}
                      render={({ field }) => (
                        <InputText
                          {...field}
                          type="text"
                          placeholder="Enter surname(s)."
                          className={`input-field appearance-none outline-none w-full ${
                            errors.name ? "error" : ""
                          }`}
                        />
                      )}
                    />
                    {errors.last_name && (
                      <small className="error-message">
                        {errors.last_name.message}
                      </small>
                    )}
                  </div>

                  <div className="field col-6">
                    <label className="contact-label mt-2">
                      Preferred Name(s)
                      <span
                        id="preferred-name-info"
                        className="pi pi-info-circle info-circle-span"
                      ></span>
                      <Tooltip
                        target="#preferred-name-info"
                        content="If the employee wants to be called by a different name than their given name, put that here."
                        position="right"
                        className="custom-tooltip tooltip-custom-format"
                      />
                    </label>
                    <Controller
                      name="preferred_name"
                      control={control}
                      defaultValues
                      rules={{
                        pattern: {
                          value: /^[A-Za-z\s]+$/,
                          message: "Special characters are not allowed.",
                        },
                      }}
                      render={({ field }) => (
                        <InputText
                          {...field}
                          type="text"
                          placeholder="Preferred name or nickname"
                          className={`input-field appearance-none outline-none w-full ${
                            errors.preferred_name ? "error" : ""
                          }`}
                        />
                      )}
                    />

                    {errors.preferred_name && (
                      <small className="error-message">
                        {errors.preferred_name.message}
                      </small>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="field col-12">
                    <label className="contact-label mt-2">Legal name*</label>
                    <Controller
                      name="legal_name"
                      control={control}
                      defaultValues
                      rules={{ required: "Legal Name is required." }}
                      render={({ field }) => (
                        <InputText
                          {...field}
                          type="text"
                          placeholder="Enter Legal Name"
                          className={`input-field appearance-none outline-none w-full ${
                            errors.legal_name ? "error" : ""
                          }`}
                        />
                      )}
                    />
                    {errors.legal_name && (
                      <small className="error-message">
                        {errors.legal_name.message}
                      </small>
                    )}
                  </div>
                </>
              )}

              <div className="field col-12">
                <label className="contact-label mt-2">Point of Contact*</label>
                <Controller
                  name="point_of_contact"
                  control={control}
                  defaultValues
                  rules={{ required: "Point of Contact is required." }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      type="text"
                      placeholder="Enter Point of Contact"
                      className={`input-field appearance-none outline-none w-full ${
                        errors.point_of_contact ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.point_of_contact && (
                  <small className="error-message">
                    {errors.point_of_contact.message}
                  </small>
                )}
              </div>
              <div className="field col-12">
                <label className="contact-label mt-2">
                  Point of Contact Email*
                </label>
                <Controller
                  name="email"
                  control={control}
                  defaultValues
                  rules={{
                    required: "Email is required.",
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "",
                    },
                  }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      type="text"
                      placeholder="Enter Email Address"
                      className={`input-field appearance-none outline-none w-full ${
                        errors.email ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.email && (
                  <small className="error-message">
                    {errors.email.message}
                  </small>
                )}
              </div>
              <div className="field col-12 md:col-12 mb-0">
                <label className="contact-label mt-2">Phone number</label>
              </div>
              <div className="field col-2 md:col-2">
                <Controller
                  name="phone_code"
                  control={control}
                  defaultValues
                  rules={{
                    pattern: {
                      value: /^[0-9]*$/,
                      message: "Phone code must contain only digits.",
                    },
                  }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      type="text"
                      placeholder="Country Code"
                      className={`input-field appearance-none outline-none w-full${
                        errors.phone_code ? "" : ""
                      }`}
                    />
                  )}
                />
                {errors.phone_code && (
                  <small className="error-message">
                    {errors.phone_code.message}
                  </small>
                )}
              </div>
              <div className="field col-10 md:col-10">
                <Controller
                  name="phone"
                  control={control}
                  defaultValues
                  rules={{
                    pattern: {
                      value: /^[0-9]*$/,
                      message: "Phone number must contain only digits.",
                    },
                  }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      type="text"
                      placeholder="Enter Phone Number"
                      className={`input-field appearance-none outline-none w-full ${
                        errors.phone ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.phone && (
                  <small className="error-message">
                    {errors.phone.message}
                  </small>
                )}
              </div>
              <div className="field col-6">
                <label className="contact-label mt-2">Number of Shares*</label>
                <Controller
                  name="number_of_shares"
                  control={control}
                  defaultValues
                  rules={{
                    required: "Number of shares is required.",
                    pattern: {
                      value: /^[0-9.]*$/,
                      message: 'Only "." is accepted for decimal places',
                    },
                    validate: (value) =>
                      value > 0 || "Number of Shares can’t be 0",
                  }}
                  render={({ field }) => (
                    <InputText
                      {...field}
                      type="text"
                      placeholder="Enter number of shares"
                      className={`input-field appearance-none outline-none w-full ${
                        errors.number_of_shares ? "error" : ""
                      }`}
                    />
                  )}
                />
                {errors.number_of_shares && (
                  <small className="error-message">
                    {errors.number_of_shares.message}
                  </small>
                )}
              </div>
              <div className="field col-6">
                <label className="contact-label mt-2">Share Percentage*</label>
                <div className="percent-input-container">
                  <Controller
                    name="share_percentage"
                    control={control}
                    defaultValues
                    rules={{
                      required: "percentage is required.",
                      pattern: {
                        value: /^[0-9.]*$/,
                        message: 'Only "." is accepted for decimal places',
                      },
                      validate: (value) =>
                        value > 0 || "Share Percentage can’t be 0",
                    }}
                    render={({ field }) => (
                      <InputText
                        {...field}
                        type="text"
                        placeholder="Enter percentage"
                        className={`input-field appearance-none outline-none w-full ${
                          errors.share_percentage ? "error" : ""
                        }`}
                      />
                    )}
                  />
                  <span className="pi pi-percentage percent-icon"></span>
                </div>
                {errors.share_percentage && (
                  <small className="error-message">
                    {errors.share_percentage.message}
                  </small>
                )}
              </div>

              <div className="field col-12">
                <div className="flex justify-content-end gap-2 mt-4">
                  <button
                    type="button"
                    className="cancel-btns"
                    onClick={handleSkip}
                  >
                    Cancel
                  </button>
                  <Button
                    loading={isBtnLoading}
                    type="submit"
                    className={`add-new-contact confirm-appointment ${!isDirty || !isValid ? "disable" : ""}`}
                    disabled={!isDirty || !isValid}
                  >
                    {!isBtnLoading &&
                      (rowData ? "Confirm Edits" : "Confirm Appointment")}
                  </Button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Card>
    </>
  );
};

export default ShareHoldersRegistration;
